import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const AlarmsSettingsContext = createContext();

export const useAlarmsSettings = () => {
  const context = useContext(AlarmsSettingsContext);
  if (!context) {
    throw new Error('useAlarmsSettings must be used within a AlarmsSettingsProvider');
  }
  return context;
};

export const AlarmsSettingsProvider = ({ children }) => {
  // Инициализируем настройки из localStorage или используем значения по умолчанию
  const initializeSettings = () => {
    const saved = localStorage.getItem('alarmsSettings');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        return {
          filterSeverity: parsed.filterSeverity || 'all',
          searchText: parsed.searchText || '',
        };
      } catch (e) {
        console.warn('Error parsing saved alarms settings:', e);
      }
    }
    return {
      filterSeverity: 'all',
      searchText: '',
    };
  };

  const [settings, setSettings] = useState(initializeSettings);

  // Сохраняем изменения в localStorage
  useEffect(() => {
    localStorage.setItem('alarmsSettings', JSON.stringify(settings));
  }, [settings]);

  const setFilterSeverity = (severity) => {
    setSettings(prev => ({ ...prev, filterSeverity: severity }));
  };

  const setSearchText = (text) => {
    setSettings(prev => ({ ...prev, searchText: text }));
  };

  const resetToDefaults = () => {
    setSettings({
      filterSeverity: 'all',
      searchText: '',
    });
  };

  const value = {
    filterSeverity: settings.filterSeverity,
    searchText: settings.searchText,
    setFilterSeverity,
    setSearchText,
    resetToDefaults
  };

  return (
    <AlarmsSettingsContext.Provider value={value}>
      {children}
    </AlarmsSettingsContext.Provider>
  );
};

AlarmsSettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}; 